export const MODIFY_FILE_INFORMATION = 'MODIFY_FILE_INFORMATION';

export function modifyFileInformation(fileInformation){
    return{
        type: MODIFY_FILE_INFORMATION,
        mainState: {
            fileInformation: fileInformation
        }
    }
}